const saleStart = new Date("2026-06-19T00:00:00");
const saleEnd = new Date("2026-06-30T23:59:59");

function updateCountdown() {
  const now = new Date();
  const label = document.querySelector("#countdown-label");
  if (!label) return;
  let target = saleStart;

  if (now >= saleStart && now <= saleEnd) {
    target = saleEnd;
    label.textContent = "Sale ends in";
  } else if (now > saleEnd) {
    label.textContent = "Sale has ended";
    ["days", "hours", "minutes"].forEach((id) => {
      document.querySelector(`#${id}`).textContent = "00";
    });
    return;
  }

  const distance = Math.max(0, target - now);
  const days = Math.floor(distance / 86400000);
  const hours = Math.floor((distance % 86400000) / 3600000);
  const minutes = Math.floor((distance % 3600000) / 60000);

  document.querySelector("#days").textContent = String(days).padStart(2, "0");
  document.querySelector("#hours").textContent = String(hours).padStart(2, "0");
  document.querySelector("#minutes").textContent = String(minutes).padStart(2, "0");
}

updateCountdown();
setInterval(updateCountdown, 30000);

const particleField = document.querySelector(".particle-field");
if (particleField) {
  for (let i = 0; i < 32; i += 1) {
    const particle = document.createElement("i");
    particle.className = "particle";
    particle.style.left = `${45 + Math.random() * 52}%`;
    particle.style.top = `${Math.random() * 100}%`;
    particle.style.animationDelay = `${Math.random() * 8}s`;
    particle.style.animationDuration = `${7 + Math.random() * 8}s`;
    particleField.appendChild(particle);
  }
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("visible");
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll(".reveal").forEach((element, index) => {
  element.style.transitionDelay = `${Math.min(index % 3, 2) * 80}ms`;
  observer.observe(element);
});

const header = document.querySelector(".site-header");
if (header) {
  window.addEventListener("scroll", () => {
    header.classList.toggle("scrolled", window.scrollY > 40);
  }, { passive: true });

  const menuButton = document.querySelector(".menu-toggle");
  if (menuButton) {
    menuButton.addEventListener("click", () => {
      const open = header.classList.toggle("menu-open");
      menuButton.setAttribute("aria-expanded", String(open));
    });
    document.querySelectorAll(".desktop-nav a").forEach((link) => {
      link.addEventListener("click", () => {
        header.classList.remove("menu-open");
        menuButton.setAttribute("aria-expanded", "false");
      });
    });
  }
}

const couponButton = document.querySelector(".coupon");
if (couponButton) {
  couponButton.addEventListener("click", async (event) => {
    const button = event.currentTarget;
    try {
      await navigator.clipboard.writeText(button.dataset.code);
      button.querySelector("i").textContent = "Copied";
    } catch {
      button.querySelector("i").textContent = "SummerSale";
    }
    setTimeout(() => {
      button.querySelector("i").textContent = "Copy";
    }, 1800);
  });
}

const numberFormatter = new Intl.NumberFormat("en-US");
const statObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    const element = entry.target;
    const target = Number(element.dataset.count);
    const suffix = element.dataset.suffix || "";
    const duration = 1200;
    const startedAt = performance.now();

    function tick(now) {
      const progress = Math.min((now - startedAt) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target < 10
        ? (target * eased).toFixed(1)
        : numberFormatter.format(Math.round(target * eased));
      element.textContent = `${current}${suffix}`;
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    statObserver.unobserve(element);
  });
}, { threshold: 0.6 });

document.querySelectorAll("[data-count]").forEach((stat) => statObserver.observe(stat));
